import { Provider } from "react-redux";
import { Outlet } from "react-router-dom";

import { CrmSessionBootstrap } from "@crm-src/CrmRoot";
import WebSocketProvider from "@crm-src/components/websocket-provider";
import { store } from "@crm-src/lib/store";

/**
 * Mount point for the Cold Email Agent pages inside the Marketing section.
 *
 * Like `MarketingCampaignsRoot`, the Cold Email Agent is a CRM-sub-app feature
 * (it reads the contacts directory and drives crm-api's `/cold_emails`
 * endpoints) surfaced at `/marketing/cold-email`. It therefore needs the same
 * runtime the `/crm` tree provides — the CRM Redux store and a freshly-minted
 * crm-api session — but WITHOUT the CRM sidebar/chrome (the Marketing shell
 * wraps it). It does NOT mount a `<Toaster>`: the shared toast store is
 * rendered once by AppShell, which this route is nested under.
 * `CrmSessionBootstrap` mints the short-TTL token and blocks children until
 * it exists; the store is a shared module-level singleton, so mounting it
 * here is safe (only one of `/crm`,
 * `/marketing/campaigns`, or `/marketing/cold-email` is mounted at a time).
 */
export function ColdEmailRoot(): JSX.Element {
  return (
    <Provider store={store}>
      <CrmSessionBootstrap>
        <WebSocketProvider>
          <Outlet />
          {/* No <Toaster> here (removed 2026-09-12, same fix as CrmRoot). This
              route is nested under the AppShell layout route, which mounts
              the ONE toaster over the ONE shared toast store — a second one
              here painted every toast twice, stacked (Cypress saw the top
              copy "covering" the bottom one). */}
        </WebSocketProvider>
      </CrmSessionBootstrap>
    </Provider>
  );
}
